(function () {
  const body = document.body;
  const header = document.querySelector("[data-header]");
  const drawers = document.querySelectorAll("[data-drawer]");
  const prefersReducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)");
  let activeDrawerTrigger = null;

  if (prefersReducedMotion?.matches) {
    body.classList.add("is-ready");
    document.querySelectorAll(".reveal-on-load").forEach((target) => {
      target.classList.add("is-visible");
      target.style.removeProperty("--motion-y");
      target.style.removeProperty("--reveal-delay");
      target.style.removeProperty("opacity");
      target.style.removeProperty("transform");
      target.style.removeProperty("transition");
    });
  } else {
    window.requestAnimationFrame(() => {
      body.classList.add("is-ready");
      window.setTimeout(() => {
        document.querySelectorAll(".reveal-on-load").forEach((target) => target.classList.add("is-visible"));
      }, 180);
    });
  }

  function setHeaderState() {
    if (!header) return;
    header.classList.toggle("is-solid", window.scrollY > 28);
  }

  function currentPath() {
    const path = window.location.pathname.replace(/\/$/, "") || "/";
    if (path === "/search") {
      const query = new URLSearchParams(window.location.search).get("q") || "";
      if (query.toLowerCase().includes("fragrance")) return "/collections/beaupan-dream-perfume";
      if (query.toLowerCase().includes("hair")) return "/collections/key-1-collection";
      if (query.toLowerCase().includes("skincare")) return "/collections/skin-care-collection";
      if (query.toLowerCase().includes("brand")) return "/pages/about-beaupan";
      if (query.toLowerCase().includes("contact")) return "/pages/contact-us";
    }
    return path;
  }

  function markActiveNavigation() {
    const activePath = currentPath();
    document.querySelectorAll(".site-header__nav-link, .mobile-nav__item--link, .site-footer__links a").forEach((link) => {
      const href = link.getAttribute("href");
      if (!href || href.startsWith("#")) return;
      let linkPath = href;
      try {
        linkPath = new URL(href, window.location.origin).pathname.replace(/\/$/, "") || "/";
      } catch {
      }
      const active = linkPath === activePath;
      link.classList.toggle("is-active", active);
      if (active) {
        link.setAttribute("aria-current", "page");
      } else {
        link.removeAttribute("aria-current");
      }
    });
  }

  function closeDrawers(options = {}) {
    const restoreFocus = options.restoreFocus !== false;
    const focusTarget = activeDrawerTrigger;
    drawers.forEach((drawer) => {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      drawer.setAttribute("inert", "");
      drawer.inert = true;
    });
    document.querySelectorAll("[data-drawer-open]").forEach((button) => {
      button.setAttribute("aria-expanded", "false");
    });
    body.classList.remove("drawer-open");
    activeDrawerTrigger = null;
    if (restoreFocus && focusTarget) {
      window.setTimeout(() => focusTarget.focus(), 80);
    }
  }

  function openDrawer(name, trigger) {
    closeDrawers({ restoreFocus: false });
    const drawer = document.querySelector(`[data-drawer="${name}"]`);
    if (!drawer) return;
    drawer.removeAttribute("inert");
    drawer.inert = false;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    body.classList.add("drawer-open");
    activeDrawerTrigger = trigger || null;
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    const focusTarget = drawer.querySelector("[data-drawer-autofocus]") || drawer.querySelector("input, button, a");
    if (focusTarget) window.setTimeout(() => focusTarget.focus(), 120);
  }

  drawers.forEach((drawer) => {
    drawer.inert = !drawer.classList.contains("is-open");
    if (drawer.inert) {
      drawer.setAttribute("inert", "");
    } else {
      drawer.removeAttribute("inert");
    }
  });

  function openDrawerAfterInteraction(name, trigger) {
    window.setTimeout(() => openDrawer(name, trigger), 0);
  }

  document.addEventListener("click", (event) => {
    const opener = event.target.closest("[data-drawer-open]");
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute("data-drawer-open"), opener);
      return;
    }

    if (event.target.closest("[data-drawer-close]")) {
      event.preventDefault();
      closeDrawers();
    }
  });

  document.querySelectorAll("[data-search-overlay-input]").forEach((input) => {
    const overlay = input.closest(".search-overlay");
    const results = overlay?.querySelectorAll("[data-search-result]");
    const suggestions = overlay?.querySelectorAll("[data-search-suggestion]");
    const suggestionsContainer = overlay?.querySelector("[data-search-suggestions]");
    const dynamicResults = overlay?.querySelector("[data-search-dynamic-results]");
    const resultsRegion = overlay?.querySelector("[data-search-results]");
    const empty = overlay?.querySelector("[data-search-empty]");
    const predictiveCopy = {
      productLabel: resultsRegion?.getAttribute("data-result-label-product") || "Product",
      collectionLabel: resultsRegion?.getAttribute("data-result-label-collection") || "Collection",
      pageLabel: resultsRegion?.getAttribute("data-result-label-page") || "Page",
      articleLabel: resultsRegion?.getAttribute("data-result-label-article") || "Journal",
      queryLabel: resultsRegion?.getAttribute("data-result-label-query") || "Search",
      productMeta: resultsRegion?.getAttribute("data-result-meta-product") || "Product",
      collectionMeta: resultsRegion?.getAttribute("data-result-meta-collection") || "Explore",
      pageMeta: resultsRegion?.getAttribute("data-result-meta-page") || "Learn",
      articleMeta: resultsRegion?.getAttribute("data-result-meta-article") || "Read",
      queryMeta: resultsRegion?.getAttribute("data-result-meta-query") || "Search"
    };
    let debounceTimer = null;
    let predictiveController = null;

    input.addEventListener("input", () => {
      const query = input.value.trim();
      const normalizedQuery = query.toLowerCase();
      overlay?.classList.toggle("is-searching", query.length > 0);
      if (suggestionsContainer) suggestionsContainer.hidden = Boolean(dynamicResults && query.length >= 2);
      suggestions?.forEach((suggestion) => {
        const keywords = suggestion.getAttribute("data-search-suggestion") || suggestion.textContent.toLowerCase();
        const active = normalizedQuery.length > 0 && keywords.split(/\s+/).some((keyword) => keyword.includes(normalizedQuery) || normalizedQuery.includes(keyword));
        suggestion.classList.toggle("is-active", active);
        if (active) {
          suggestion.setAttribute("aria-current", "true");
        } else {
          suggestion.removeAttribute("aria-current");
        }
      });

      if (dynamicResults) {
        window.clearTimeout(debounceTimer);
        if (predictiveController) predictiveController.abort();
        dynamicResults.innerHTML = "";
        overlay?.classList.remove("is-loading");
        if (resultsRegion) resultsRegion.setAttribute("aria-busy", "false");
        if (empty) empty.hidden = true;

        if (query.length < 2) return;

        debounceTimer = window.setTimeout(async () => {
          predictiveController = new AbortController();
          overlay?.classList.add("is-loading");
          if (resultsRegion) resultsRegion.setAttribute("aria-busy", "true");

          try {
            const response = await fetch(predictiveSearchEndpoint(query), {
              credentials: "same-origin",
              headers: { Accept: "application/json" },
              signal: predictiveController.signal
            });
            if (!response.ok) throw new Error("Predictive search request failed");
            const suggestions = await response.json();
            const items = buildPredictiveItems(suggestions, predictiveCopy).slice(0, 6);
            renderPredictiveSearchResults(dynamicResults, items);
            if (empty) empty.hidden = items.length > 0;
          } catch (error) {
            if (error.name !== "AbortError") {
              renderPredictiveSearchResults(dynamicResults, []);
              if (empty) empty.hidden = false;
            }
          } finally {
            overlay?.classList.remove("is-loading");
            if (resultsRegion) resultsRegion.setAttribute("aria-busy", "false");
          }
        }, 180);
        return;
      }

      if (!results || results.length === 0) return;
      let visibleCount = 0;
      results.forEach((result) => {
        const keywords = result.getAttribute("data-search-keywords") || result.textContent.toLowerCase();
        const visible = normalizedQuery.length > 0 && keywords.includes(normalizedQuery);
        result.hidden = !visible || visibleCount >= 4;
        if (visible) visibleCount += 1;
      });
      if (empty) empty.hidden = normalizedQuery.length === 0 || visibleCount > 0;
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeDrawers();
      return;
    }

    const typingTarget = event.target.closest("input, textarea, select, [contenteditable='true']");
    if (!typingTarget && (event.key === "/" || (event.key.toLowerCase() === "k" && (event.metaKey || event.ctrlKey)))) {
      event.preventDefault();
      openDrawer("search", document.querySelector('[data-drawer-open="search"]'));
      return;
    }

    if (event.key !== "Tab" || !body.classList.contains("drawer-open")) return;
    const openDrawerElement = document.querySelector(".drawer.is-open");
    const focusable = openDrawerElement?.querySelectorAll("a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex='-1'])");
    if (!focusable || focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function shopifyEndpoint(path) {
    const shopifyRoot = window.Shopify?.routes?.root;
    const liquidRoot = header?.getAttribute("data-cart-root");
    const root = shopifyRoot || liquidRoot || "/";
    return `${root.endsWith("/") ? root : `${root}/`}${path}`;
  }

  function cartEndpoint(path) {
    return shopifyEndpoint(path);
  }

  function predictiveSearchEndpoint(query) {
    const params = new URLSearchParams({
      q: query,
      "resources[type]": "product,collection,page,article,query",
      "resources[limit]": "6",
      "resources[limit_scope]": "all",
      "resources[options][unavailable_products]": "last"
    });
    return `${shopifyEndpoint("search/suggest.json")}?${params.toString()}`;
  }

  function searchUrlForQuery(query) {
    return `${shopifyEndpoint("search")}?q=${encodeURIComponent(query)}`;
  }

  function predictiveProductMeta(product, copy = {}) {
    const price = product.price ?? product.price_min ?? product.compare_at_price_min;
    if (typeof price === "number" || /^\d+$/.test(String(price || ""))) return formatMoney(price);
    return product.product_type || product.vendor || copy.productMeta || "Product";
  }

  const blockedSearchResultTerms = [
    "rx-1",
    "rx 1",
    "Advanced Whitening",
    "whitening & brightening",
    "Anti-freckle",
    "freckle",
    "tripeptide-1 solution",
    "medical beauty",
    "skin stabilizer",
    "corrective serum"
  ];

  function shouldHideSearchResultItem(item) {
    const text = [
      item?.title,
      item?.url,
      item?.meta,
      item?.label
    ].filter(Boolean).join(" ").toLowerCase();
    return blockedSearchResultTerms.some((term) => text.includes(String(term).toLowerCase()));
  }

  function buildPredictiveItems(data, copy = {}) {
    const results = data?.resources?.results || {};
    const labels = {
      productLabel: copy.productLabel || "Product",
      collectionLabel: copy.collectionLabel || "Collection",
      pageLabel: copy.pageLabel || "Page",
      articleLabel: copy.articleLabel || "Journal",
      queryLabel: copy.queryLabel || "Search",
      productMeta: copy.productMeta || "Product",
      collectionMeta: copy.collectionMeta || "Explore",
      pageMeta: copy.pageMeta || "Learn",
      articleMeta: copy.articleMeta || "Read",
      queryMeta: copy.queryMeta || "Search"
    };
    const items = [];

    (results.products || []).forEach((product) => {
      items.push({
        label: labels.productLabel,
        meta: predictiveProductMeta(product, labels),
        title: product.title,
        url: product.url
      });
    });

    (results.collections || []).forEach((collection) => {
      items.push({
        label: labels.collectionLabel,
        meta: labels.collectionMeta,
        title: collection.title,
        url: collection.url
      });
    });

    (results.pages || []).forEach((page) => {
      items.push({
        label: labels.pageLabel,
        meta: labels.pageMeta,
        title: page.title,
        url: page.url
      });
    });

    (results.articles || []).forEach((article) => {
      items.push({
        label: labels.articleLabel,
        meta: labels.articleMeta,
        title: article.title,
        url: article.url
      });
    });

    (results.queries || []).forEach((query) => {
      const text = typeof query === "string" ? query : query.text || query.title;
      items.push({
        label: labels.queryLabel,
        meta: labels.queryMeta,
        title: text,
        url: query.url || searchUrlForQuery(text)
      });
    });

    return items.filter((item) => item.title && item.url && !shouldHideSearchResultItem(item));
  }

  function renderPredictiveSearchResults(container, items) {
    container.innerHTML = items.map((item) => `
      <a href="${escapeHtml(item.url)}" data-search-generated>
        <span class="search-overlay__result-copy">
          <strong>${escapeHtml(item.title)}</strong>
          <small>${escapeHtml(item.label)}</small>
        </span>
        <span>${escapeHtml(item.meta)}</span>
      </a>
    `).join("");
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || "USD";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        currency,
        style: "currency"
      }).format(Number(cents || 0) / 100);
    } catch {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  }

  const cartContent = document.querySelector("[data-cart-drawer-content]");

  function renderCartDrawer(cart, statusText) {
    if (!cartContent) return;
    const cartUrl = cartContent.getAttribute("data-cart-url") || "/cart";
    const collectionUrl = cartContent.getAttribute("data-all-products-url") || "/collections/skin-care-collection";
    const emptyText = cartContent.getAttribute("data-empty-text") || "Your bag is empty.";
    const continueText = cartContent.getAttribute("data-continue-shopping-text") || "Continue shopping";
    const subtotalText = cartContent.getAttribute("data-subtotal-text") || "Subtotal";
    const checkoutText = cartContent.getAttribute("data-checkout-text") || "Checkout";
    const viewCartText = cartContent.getAttribute("data-view-cart-text") || "View shopping bag";
    const quantityTemplate = cartContent.getAttribute("data-quantity-template") || "Qty {count}";
    const removeText = cartContent.getAttribute("data-remove-text") || "Remove";
    const removeItemTemplate = cartContent.getAttribute("data-remove-item-template") || "Remove {title}";
    const statusMarkup = statusText ? `<p class="cart-drawer__status" role="status">${escapeHtml(statusText)}</p>` : "";

    if (!cart || !cart.item_count) {
      cartContent.innerHTML = `
        <div data-cart-empty>
          <p class="drawer__empty">${escapeHtml(emptyText)}</p>
          <a class="button button--dark" href="${escapeHtml(collectionUrl)}">${escapeHtml(continueText)}</a>
          ${statusMarkup}
        </div>
      `;
      return;
    }

    const itemsMarkup = cart.items
      .map((item) => {
        const title = item.product_title || item.title || "";
        const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(title)}" width="160" height="160" loading="lazy">` : "";
        const removeUrl = `/cart/change?id=${encodeURIComponent(item.key || item.variant_id || "")}&quantity=0`;
        return `
          <div class="cart-drawer__item is-entering">
            ${image}
            <div>
              <a href="${escapeHtml(item.url || cartUrl)}">${escapeHtml(title)}</a>
              <div class="cart-drawer__meta">
                <span>${formatMoney(item.final_line_price)}</span>
                <span class="cart-drawer__quantity">${escapeHtml(quantityTemplate.replace("{count}", item.quantity))}</span>
                <a class="cart-line__remove cart-drawer__remove" href="${escapeHtml(removeUrl)}" aria-label="${escapeHtml(removeItemTemplate.replace("{title}", title))}">${escapeHtml(removeText)}</a>
              </div>
            </div>
          </div>
        `;
      })
      .join("");

    cartContent.innerHTML = `
      ${statusMarkup}
      <form action="${escapeHtml(cartUrl)}" method="post" class="cart-drawer__items is-entering">
        ${itemsMarkup}
        <div class="cart-drawer__total">
          <span>${escapeHtml(subtotalText)}</span>
          <strong>${formatMoney(cart.total_price)}</strong>
        </div>
        <button class="button button--dark" type="submit" name="checkout">${escapeHtml(checkoutText)}</button>
        <a class="text-link" href="${escapeHtml(cartUrl)}">${escapeHtml(viewCartText)}</a>
      </form>
    `;
  }

  function showCartStatus(message) {
    if (!cartContent || !message) return;
    const existing = cartContent.querySelector(".cart-drawer__status");
    if (existing) {
      existing.textContent = message;
      return;
    }
    cartContent.insertAdjacentHTML("afterbegin", `<p class="cart-drawer__status" role="status">${escapeHtml(message)}</p>`);
  }

  function bumpCartCount(item) {
    if (!item) return;
    item.classList.remove("is-bumped");
    void item.offsetWidth;
    item.classList.add("is-bumped");
  }

  function updateCartCount(count) {
    const nextCount = String(count || 0);
    document.querySelectorAll("[data-cart-count]").forEach((item) => {
      const changed = item.textContent.trim() !== nextCount;
      item.textContent = nextCount;
      if (changed) bumpCartCount(item);
    });
  }

  async function fetchCart() {
    const response = await fetch(cartEndpoint("cart.js"), {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    });
    if (!response.ok) throw new Error("Cart request failed");
    return response.json();
  }

  function setAddButtonState(button, state) {
    if (!button) return;
    const idleText = button.getAttribute("data-add-to-cart-text") || button.textContent.trim();
    const loadingText = button.getAttribute("data-adding-text") || idleText;
    const addedText = button.getAttribute("data-added-text") || idleText;
    button.classList.remove("is-loading", "is-added", "is-error");
    button.disabled = state === "loading" || state === "added";

    if (state === "loading") {
      button.classList.add("is-loading");
      button.textContent = loadingText;
    } else if (state === "added") {
      button.classList.add("is-added");
      button.textContent = addedText;
    } else if (state === "error") {
      button.classList.add("is-error");
      button.textContent = idleText;
    } else {
      button.textContent = idleText;
    }
  }

  document.querySelectorAll("[data-tabs]").forEach((tabs) => {
    const buttons = tabs.querySelectorAll("[data-tab-button]");
    const panels = tabs.querySelectorAll("[data-tab-panel]");
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const target = button.getAttribute("data-tab-button");
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle("is-active", active);
          item.setAttribute("aria-selected", active ? "true" : "false");
        });
        panels.forEach((panel) => {
          const active = panel.getAttribute("data-tab-panel") === target;
          panel.classList.toggle("is-active", active);
          panel.hidden = !active;
          if (active) {
            window.requestAnimationFrame(() => {
              panel.dispatchEvent(new CustomEvent("loop-carousel:refresh"));
            });
          }
        });
      });
    });
  });

  function enableDragScroll(rail) {
    let isDragging = false;
    let didDrag = false;
    let suppressClick = false;
    let startX = 0;
    let startScrollLeft = 0;

    rail.addEventListener("pointerdown", (event) => {
      if (event.button !== 0) return;
      const interactiveTarget = event.target instanceof Element && event.target.closest("a, button, input, textarea, select, summary, label");
      if (interactiveTarget) return;
      isDragging = true;
      didDrag = false;
      startX = event.clientX;
      startScrollLeft = rail.scrollLeft;
      rail.classList.add("is-dragging");
      rail.setPointerCapture?.(event.pointerId);
    });

    rail.addEventListener("pointermove", (event) => {
      if (!isDragging) return;
      const deltaX = event.clientX - startX;
      if (Math.abs(deltaX) > 4) didDrag = true;
      rail.scrollLeft = startScrollLeft - deltaX;
      if (didDrag) event.preventDefault();
    });

    function endDrag(event) {
      if (!isDragging) return;
      isDragging = false;
      suppressClick = didDrag;
      rail.classList.remove("is-dragging");
      try {
        rail.releasePointerCapture?.(event.pointerId);
      } catch {
      }
    }

    rail.addEventListener("pointerup", endDrag);
    rail.addEventListener("pointercancel", endDrag);
    rail.addEventListener("pointerleave", endDrag);
    rail.addEventListener(
      "click",
      (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      },
      true
    );
  }

  function setupLoopCarousel(rail) {
    if (window.Shopify?.designMode) return;
    const originals = Array.from(rail.children).filter((child) => child instanceof HTMLElement && !child.hasAttribute("data-loop-clone"));
    if (originals.length < 1) return;

    const clones = [];
    let cloneSetCount = 0;
    let firstClone = null;

    function appendCloneSet() {
      cloneSetCount += 1;
      originals.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute("data-loop-clone", "true");
        clone.setAttribute("data-loop-clone-set", String(cloneSetCount));
        clone.setAttribute("aria-hidden", "true");
        clone.classList.add("reveal-ready", "is-visible");
        clone.style.setProperty("--reveal-delay", "0ms");
        clone.querySelectorAll("a, button, input, select, textarea").forEach((control) => {
          control.setAttribute("tabindex", "-1");
        });
        rail.appendChild(clone);
        clones.push(clone);
        if (!firstClone) firstClone = clone;
      });
    }

    appendCloneSet();

    let cycleWidth = 0;
    let lastFrame = 0;
    let scrollPosition = rail.scrollLeft;
    let scrollQueued = false;
    const speed = Number(rail.getAttribute("data-loop-speed") || 0.06);
    const localMotionPreview = body.hasAttribute("data-local-motion-preview");
    const autoplay = localMotionPreview || !prefersReducedMotion?.matches;

    function measure() {
      if (rail.hidden || rail.getClientRects().length === 0 || rail.clientWidth <= 0) return false;
      const first = originals[0];
      const nextCycleWidth = first && firstClone ? firstClone.offsetLeft - first.offsetLeft : rail.scrollWidth / 2;
      if (!Number.isFinite(nextCycleWidth) || nextCycleWidth <= 0) return false;
      const requiredCycleSets = Math.max(1, Math.ceil((rail.clientWidth + 32) / nextCycleWidth));
      cycleWidth = nextCycleWidth * requiredCycleSets;
      while (cycleWidth > 0 && rail.scrollWidth - rail.clientWidth <= cycleWidth + 32) {
        appendCloneSet();
      }
      return true;
    }

    function normalize() {
      if (cycleWidth <= 0) return;
      while (scrollPosition >= cycleWidth) scrollPosition -= cycleWidth;
      while (scrollPosition < 0) scrollPosition += cycleWidth;
      if (Math.abs(rail.scrollLeft - scrollPosition) > 0.5) rail.scrollLeft = scrollPosition;
    }

    function isActive() {
      return !rail.hidden && rail.classList.contains("is-active") && rail.getClientRects().length > 0;
    }

    function tick(timestamp) {
      if (!lastFrame) lastFrame = timestamp;
      const delta = timestamp - lastFrame;
      lastFrame = timestamp;
      if (autoplay && isActive() && document.visibilityState === "visible" && !rail.classList.contains("is-dragging") && (localMotionPreview || !rail.matches(":focus-within"))) {
        if (cycleWidth <= 0 && !measure()) {
          window.requestAnimationFrame(tick);
          return;
        }
        scrollPosition += Math.min(delta, 48) * speed;
        rail.scrollLeft = scrollPosition;
        normalize();
      }
      window.requestAnimationFrame(tick);
    }

    rail.addEventListener("loop-carousel:refresh", () => {
      window.requestAnimationFrame(() => {
        if (measure()) {
          scrollPosition = rail.scrollLeft;
          normalize();
        }
      });
    });

    rail.addEventListener(
      "scroll",
      () => {
        if (scrollQueued) return;
        scrollQueued = true;
        window.requestAnimationFrame(() => {
          if (!autoplay || !isActive() || rail.classList.contains("is-dragging")) {
            scrollPosition = rail.scrollLeft;
          }
          normalize();
          scrollQueued = false;
        });
      },
      { passive: true }
    );

    window.addEventListener("resize", measure, { passive: true });
    measure();
    if (autoplay) window.requestAnimationFrame(tick);
  }

  document.querySelectorAll("[data-loop-carousel]").forEach(setupLoopCarousel);
  document.querySelectorAll(".product-rail").forEach(enableDragScroll);

  document.querySelectorAll("[data-product-page]").forEach((page) => {
    const gallery = page.querySelector("[data-product-gallery]");
    const main = gallery?.querySelector("[data-gallery-main]");
    const thumbs = Array.from(page.querySelectorAll("[data-gallery-thumb]"));
    const slides = Array.from(page.querySelectorAll("[data-gallery-slide]"));
    if (!gallery || slides.length === 0) return;
    const autoplayDelay = Math.max(0, Number(gallery.getAttribute("data-gallery-autoplay") || 0));
    let autoplayTimer = null;
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));

    function canAutoplay() {
      return slides.length > 1 && autoplayDelay >= 1000 && !prefersReducedMotion?.matches;
    }

    function setActiveSlide(index) {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-hidden", active ? "false" : "true");
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === activeIndex;
        thumb.classList.toggle("is-active", active);
        if (active) {
          thumb.setAttribute("aria-current", "true");
        } else {
          thumb.removeAttribute("aria-current");
        }
      });
    }

    function stopAutoplay() {
      if (!autoplayTimer) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!canAutoplay()) return;
      autoplayTimer = window.setInterval(() => {
        setActiveSlide(activeIndex + 1);
      }, autoplayDelay);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    page.addEventListener("beaupan:variant-media-change", (event) => {
      const mediaId = String(event.detail?.mediaId || "");
      if (!mediaId) return;
      const mediaSlide = slides.find((slide) => slide.getAttribute("data-media-id") === mediaId);
      if (!mediaSlide) return;
      setActiveSlide(Number(mediaSlide.getAttribute("data-gallery-slide") || 0));
      restartAutoplay();
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        setActiveSlide(Number(thumb.getAttribute("data-gallery-thumb") || 0));
        restartAutoplay();
      });
    });

    function activateGalleryControl(control) {
      if (!control) return false;
      if (control.matches("[data-gallery-prev]")) {
        setActiveSlide(activeIndex - 1);
      } else if (control.matches("[data-gallery-next]")) {
        setActiveSlide(activeIndex + 1);
      } else {
        return false;
      }
      restartAutoplay();
      return true;
    }

    let lastPointerControlActivation = 0;
    gallery.addEventListener(
      "pointerup",
      (event) => {
        const control = event.target instanceof Element ? event.target.closest("[data-gallery-control]") : null;
        if (!control || !gallery.contains(control)) return;
        event.preventDefault();
        event.stopPropagation();
        if (activateGalleryControl(control)) {
          lastPointerControlActivation = Date.now();
        }
      },
      true
    );

    gallery.addEventListener(
      "click",
      (event) => {
        const control = event.target instanceof Element ? event.target.closest("[data-gallery-control]") : null;
        if (!control || !gallery.contains(control)) return;
        event.preventDefault();
        event.stopPropagation();
        if (Date.now() - lastPointerControlActivation < 450) return;
        activateGalleryControl(control);
      },
      true
    );

    let startX = 0;
    let trackingSwipe = false;
    main?.addEventListener("pointerdown", (event) => {
      if (event.button !== 0) return;
      if (event.target instanceof Element && event.target.closest("[data-gallery-control]")) return;
      trackingSwipe = true;
      startX = event.clientX;
      main.setPointerCapture?.(event.pointerId);
    });

    function endSwipe(event) {
      if (!trackingSwipe) return;
      trackingSwipe = false;
      const deltaX = event.clientX - startX;
      if (Math.abs(deltaX) > 34) {
        setActiveSlide(activeIndex + (deltaX < 0 ? 1 : -1));
        restartAutoplay();
      }
      try {
        main?.releasePointerCapture?.(event.pointerId);
      } catch {
      }
    }

    main?.addEventListener("pointerup", endSwipe);
    main?.addEventListener("pointercancel", () => {
      trackingSwipe = false;
    });
    gallery.addEventListener("focusin", stopAutoplay);
    gallery.addEventListener("focusout", startAutoplay);
    gallery.addEventListener("pointerenter", (event) => {
      if (event.pointerType === "mouse") stopAutoplay();
    });
    gallery.addEventListener("pointerleave", (event) => {
      if (event.pointerType === "mouse") startAutoplay();
    });
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });
    prefersReducedMotion?.addEventListener?.("change", () => {
      if (prefersReducedMotion.matches) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });
    setActiveSlide(activeIndex);
    startAutoplay();
  });

  document.querySelectorAll("[data-quantity-stepper]").forEach((stepper) => {
    const input = stepper.querySelector("[data-quantity-input]");
    const decreaseButton = stepper.querySelector("[data-quantity-decrease]");
    const increaseButton = stepper.querySelector("[data-quantity-increase]");
    const cartForm = stepper.closest(".cart-page__form");
    let cartUpdateTimer = null;
    if (!input || !decreaseButton || !increaseButton) return;

    const getMin = () => Math.max(1, Number(input.getAttribute("min") || 1));
    const getMax = () => {
      const max = Number(input.getAttribute("max"));
      return Number.isFinite(max) && max > 0 ? max : Infinity;
    };

    const normalizeQuantity = () => {
      const min = getMin();
      const max = getMax();
      const current = Number(input.value);
      const normalized = Math.min(max, Math.max(min, Number.isFinite(current) && current > 0 ? Math.round(current) : min));
      input.value = String(normalized);
      decreaseButton.disabled = normalized <= min;
      increaseButton.disabled = normalized >= max;
    };

    const changeQuantity = (delta) => {
      normalizeQuantity();
      const min = getMin();
      const max = getMax();
      const nextValue = Math.min(max, Math.max(min, Number(input.value || min) + delta));
      input.value = String(nextValue);
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
      normalizeQuantity();
    };

    const scheduleCartUpdate = () => {
      if (!cartForm) return;
      window.clearTimeout(cartUpdateTimer);
      cartUpdateTimer = window.setTimeout(() => {
        if (typeof cartForm.requestSubmit === "function") {
          cartForm.requestSubmit();
        } else {
          cartForm.submit();
        }
      }, 300);
    };

    decreaseButton.addEventListener("click", () => changeQuantity(-1));
    increaseButton.addEventListener("click", () => changeQuantity(1));
    if (cartForm) {
      decreaseButton.addEventListener("click", scheduleCartUpdate);
      increaseButton.addEventListener("click", scheduleCartUpdate);
    }
    input.addEventListener("input", normalizeQuantity);
    input.addEventListener("change", () => {
      normalizeQuantity();
      scheduleCartUpdate();
    });
    normalizeQuantity();
  });

  function activateProductMediaById(page, mediaId) {
    if (!page || !mediaId) return false;
    const matchingThumb = Array.from(page.querySelectorAll("[data-gallery-thumb]")).find((thumb) => thumb.getAttribute("data-media-id") === mediaId);
    if (matchingThumb instanceof HTMLElement) {
      matchingThumb.click();
      return true;
    }
    const matchingSlide = Array.from(page.querySelectorAll("[data-gallery-slide]")).find((slide) => slide.getAttribute("data-media-id") === mediaId);
    const slideIndex = matchingSlide?.getAttribute("data-gallery-slide");
    const fallbackThumb = slideIndex ? page.querySelector(`[data-gallery-thumb="${slideIndex}"]`) : null;
    if (fallbackThumb instanceof HTMLElement) {
      fallbackThumb.click();
      return true;
    }
    return false;
  }

  function triggerProductMediaChange(page, mediaId) {
    if (!page || !mediaId) return;
    try {
      if (typeof CustomEvent === "function") {
        page.dispatchEvent(new CustomEvent("beaupan:variant-media-change", { detail: { mediaId } }));
        return;
      }
      if (typeof document.createEvent === "function") {
        const event = document.createEvent("CustomEvent");
        event.initCustomEvent("beaupan:variant-media-change", true, true, { mediaId });
        page.dispatchEvent(event);
        return;
      }
    } catch {
      // Fall through to the direct thumbnail activation path.
    }
    activateProductMediaById(page, mediaId);
  }

  document.querySelectorAll(".js-product-form").forEach((form) => {
    const page = form.closest("[data-product-page]");
    const variantSelect = form.querySelector("[data-variant-select]");
    const priceOutput = page?.querySelector("[data-product-price]");
    const skuOutput = page?.querySelector("[data-product-sku]");
    const skuItem = page?.querySelector("[data-product-sku-item]");
    const availabilityOutput = page?.querySelector("[data-product-availability]");
    const submitButton = form.querySelector("[data-product-submit]");

    function syncVariantState() {
      if (!variantSelect) return;
      const selectedOption = variantSelect.selectedOptions?.[0];
      if (!selectedOption) return;
      const nextPrice = selectedOption.getAttribute("data-variant-price");
      const isAvailable = selectedOption.getAttribute("data-variant-available") !== "false";
      const variantSku = selectedOption.getAttribute("data-variant-sku") || "";
      const variantAvailability = selectedOption.getAttribute("data-variant-availability");
      const variantMediaId = selectedOption.getAttribute("data-variant-media-id");
      const variantTitle = selectedOption.getAttribute("data-variant-title");
      const variantImage = selectedOption.getAttribute("data-variant-image");
      const variantUrl = selectedOption.getAttribute("data-variant-url");
      if (priceOutput && nextPrice) priceOutput.textContent = nextPrice;
      if (skuOutput) skuOutput.textContent = variantSku;
      if (skuItem) skuItem.hidden = !variantSku;
      if (availabilityOutput && variantAvailability) availabilityOutput.textContent = variantAvailability;
      if (submitButton) {
        if (nextPrice) submitButton.setAttribute("data-product-price", nextPrice);
        if (variantTitle) submitButton.setAttribute("data-product-title", variantTitle);
        if (variantImage) submitButton.setAttribute("data-product-image", variantImage);
        if (variantUrl) submitButton.setAttribute("data-product-url", variantUrl);
        submitButton.disabled = !isAvailable;
        submitButton.textContent = isAvailable
          ? submitButton.getAttribute("data-add-to-cart-text") || submitButton.textContent
          : submitButton.getAttribute("data-sold-out-text") || "Sold out";
      }
      if (variantMediaId) {
        triggerProductMediaChange(page, variantMediaId);
      }
    }

    variantSelect?.addEventListener("change", syncVariantState);
    syncVariantState();

    form.addEventListener("submit", async (event) => {
      const variantInput = form.querySelector('[name="id"]');
      const currentSubmitButton = form.querySelector('[type="submit"]');
      if (!variantInput || !window.fetch) return;

      event.preventDefault();
      if (currentSubmitButton?.disabled) return;

      const quantityInput = form.querySelector('[name="quantity"]');
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const variantId = Number(variantInput.value);
      if (!variantId) return;

      const drawerTrigger = document.querySelector('[data-drawer-open="cart"]');
      const addedStatus = cartContent?.getAttribute("data-added-status") || "Added to your bag.";
      const errorText = cartContent?.getAttribute("data-error-text") || "We could not add that item. Please try again.";

      try {
        cartContent?.classList.add("is-updating");
        setAddButtonState(currentSubmitButton, "loading");
        const addResponse = await fetch(cartEndpoint("cart/add.js"), {
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity
              }
            ]
          }),
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          method: "POST"
        });
        const addData = await addResponse.json().catch(() => ({}));
        if (!addResponse.ok) {
          throw new Error(addData.description || addData.message || errorText);
        }

        const cart = await fetchCart();
        updateCartCount(cart.item_count);
        renderCartDrawer(cart, addedStatus);
        setAddButtonState(currentSubmitButton, "added");
        openDrawerAfterInteraction("cart", drawerTrigger);
        window.setTimeout(() => {
          setAddButtonState(currentSubmitButton, "idle");
          syncVariantState();
        }, 1800);
      } catch (error) {
        setAddButtonState(currentSubmitButton, "error");
        try {
          const cart = await fetchCart();
          updateCartCount(cart.item_count);
          renderCartDrawer(cart, error?.message || errorText);
        } catch {
          showCartStatus(error?.message || errorText);
        }
        openDrawerAfterInteraction("cart", drawerTrigger);
        window.setTimeout(() => {
          setAddButtonState(currentSubmitButton, "idle");
          syncVariantState();
        }, 2200);
      } finally {
        cartContent?.classList.remove("is-updating");
      }
    });
  });

  const localCart = document.querySelector("[data-local-cart]");
  if (localCart) {
    const emptyState = localCart.querySelector("[data-local-cart-empty]");
    const filledState = localCart.querySelector("[data-local-cart-filled]");
    const itemLines = localCart.querySelector("[data-local-cart-lines]");
    const subtotal = localCart.querySelector("[data-local-cart-subtotal]");
    const localCartPage = document.querySelector("[data-local-cart-page]");
    const pageEmptyState = localCartPage?.querySelector("[data-local-cart-page-empty]");
    const pageFilledState = localCartPage?.querySelector("[data-local-cart-page-filled]");
    const pageLines = localCartPage?.querySelector("[data-local-cart-page-lines]");
    const pageSubtotal = localCartPage?.querySelector("[data-local-cart-page-subtotal]");
    const localRemoveText = localCart.getAttribute("data-remove-text") || "Remove";
    const localRemoveItemTemplate = localCart.getAttribute("data-remove-item-template") || "Remove {title}";
    const localQuantityShort = localCart.getAttribute("data-local-cart-quantity-short") || localCart.getAttribute("data-quantity-short") || "Qty";
    const localQuantityTemplate = localCart.getAttribute("data-local-cart-quantity-template") || localCart.getAttribute("data-quantity-template") || "x{count}";
    const localQuantityItemTemplate = localCart.getAttribute("data-local-cart-quantity-item-template") || localCart.getAttribute("data-quantity-item-template") || "Quantity for {title}";
    const localQuantityDecrease = localCart.getAttribute("data-local-cart-quantity-decrease-text") || localCart.getAttribute("data-quantity-decrease") || "Decrease quantity";
    const localQuantityIncrease = localCart.getAttribute("data-local-cart-quantity-increase-text") || localCart.getAttribute("data-quantity-increase") || "Increase quantity";
    const localCartStorageKey = "beaupanLocalCart";

    function parseLocalPrice(price) {
      return Number(String(price || "").replace(/[^0-9.]/g, "")) || 0;
    }

    function formatLocalPrice(amount) {
      return `$${amount.toFixed(2)}`;
    }

    function localCartKey(item) {
      return item?.url || item?.title || "BEAUPAN ritual";
    }

    function normalizeLocalCartItem(item) {
      return {
        image: item?.image || "",
        key: localCartKey(item),
        price: item?.price || "$68.00",
        quantity: Math.max(1, Number(item?.quantity || 1)),
        title: item?.title || "BEAUPAN ritual",
        url: item?.url || "/collections/skin-care-collection"
      };
    }

    function normalizeLocalCartItems(value) {
      const rawItems = Array.isArray(value) ? value : value ? [value] : [];
      const merged = new Map();
      rawItems.forEach((rawItem) => {
        const item = normalizeLocalCartItem(rawItem);
        const existing = merged.get(item.key);
        if (existing) {
          existing.quantity += item.quantity;
        } else {
          merged.set(item.key, item);
        }
      });
      return Array.from(merged.values());
    }

    function readLocalCartItems() {
      try {
        const value = window.localStorage.getItem(localCartStorageKey);
        return value ? normalizeLocalCartItems(JSON.parse(value)) : [];
      } catch {
        return [];
      }
    }

    function writeLocalCartItems(items) {
      try {
        const normalizedItems = normalizeLocalCartItems(items);
        if (normalizedItems.length === 0) {
          window.localStorage.removeItem(localCartStorageKey);
          return;
        }
        window.localStorage.setItem(localCartStorageKey, JSON.stringify(normalizedItems));
      } catch {
        return;
      }
    }

    function localCartTotals(items) {
      return items.reduce((totals, item) => {
        const amount = parseLocalPrice(item.price) * item.quantity;
        return {
          count: totals.count + item.quantity,
          subtotal: totals.subtotal + amount
        };
      }, { count: 0, subtotal: 0 });
    }

    function renderLocalCartDrawer(items) {
      if (!itemLines) return;
      itemLines.innerHTML = items.map((item) => `
        <div class="cart-drawer__item is-entering">
          ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" width="160" height="160" loading="lazy">` : ""}
          <div>
            <a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
            <div class="cart-drawer__meta">
              <span>${escapeHtml(item.price)}</span>
              <span class="cart-drawer__quantity">${escapeHtml(localQuantityTemplate.replace("{count}", item.quantity))}</span>
              <button class="cart-line__remove cart-drawer__remove" type="button" data-local-cart-remove data-local-cart-key="${escapeHtml(item.key)}" aria-label="${escapeHtml(localRemoveItemTemplate.replace("{title}", item.title))}">${escapeHtml(localRemoveText)}</button>
            </div>
          </div>
        </div>
      `).join("");
    }

    function renderLocalCartPage(items) {
      if (!localCartPage) return;
      if (items.length === 0) {
        if (pageEmptyState) pageEmptyState.hidden = false;
        if (pageFilledState) pageFilledState.hidden = true;
        if (pageLines) pageLines.innerHTML = "";
        if (pageSubtotal) pageSubtotal.textContent = formatLocalPrice(0);
        return;
      }
      if (pageEmptyState) pageEmptyState.hidden = true;
      if (pageFilledState) pageFilledState.hidden = false;
      if (pageLines) {
        pageLines.innerHTML = items.map((item) => {
          const lineTotal = parseLocalPrice(item.price) * item.quantity;
          return `
            <div class="cart-line" data-local-cart-page-line data-local-cart-key="${escapeHtml(item.key)}">
              <a href="${escapeHtml(item.url)}">
                ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" width="220" height="220" loading="lazy">` : ""}
              </a>
              <div class="cart-line__details">
                <a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
                <div class="cart-line__meta">
                  <span>${escapeHtml(item.price)}</span>
                  <span>${escapeHtml(localQuantityTemplate.replace("{count}", item.quantity))}</span>
                  <button class="cart-line__remove" type="button" data-local-cart-remove data-local-cart-key="${escapeHtml(item.key)}" aria-label="${escapeHtml(localRemoveItemTemplate.replace("{title}", item.title))}">${escapeHtml(localRemoveText)}</button>
                </div>
                <label class="cart-line__quantity">
                  <span>${escapeHtml(localQuantityShort)}</span>
                  <span class="quantity-stepper">
                    <button class="quantity-stepper__button" type="button" data-local-cart-quantity-decrease data-local-cart-key="${escapeHtml(item.key)}" aria-label="${escapeHtml(localQuantityDecrease)}">-</button>
                    <input type="number" min="1" value="${item.quantity}" inputmode="numeric" data-local-cart-page-line-quantity data-local-cart-key="${escapeHtml(item.key)}" aria-label="${escapeHtml(localQuantityItemTemplate.replace("{title}", item.title))}">
                    <button class="quantity-stepper__button" type="button" data-local-cart-quantity-increase data-local-cart-key="${escapeHtml(item.key)}" aria-label="${escapeHtml(localQuantityIncrease)}">+</button>
                  </span>
                </label>
              </div>
              <strong>${formatLocalPrice(lineTotal)}</strong>
            </div>
          `;
        }).join("");
      }
      if (pageSubtotal) pageSubtotal.textContent = formatLocalPrice(localCartTotals(items).subtotal);
    }

    function updateLocalCartItems(items, options = {}) {
      const cartItems = normalizeLocalCartItems(items);
      const totals = localCartTotals(cartItems);
      document.querySelectorAll("[data-cart-count]").forEach((count) => {
        const nextCount = String(totals.count);
        const changed = count.textContent.trim() !== nextCount;
        count.textContent = nextCount;
        if (changed) bumpCartCount(count);
      });
      const isEmpty = cartItems.length === 0;
      if (emptyState) emptyState.hidden = !isEmpty;
      if (filledState) filledState.hidden = isEmpty;
      if (subtotal) subtotal.textContent = formatLocalPrice(totals.subtotal);
      renderLocalCartDrawer(cartItems);
      renderLocalCartPage(cartItems);
      if (options.persist !== false) writeLocalCartItems(cartItems);
    }

    function addLocalCartItem(item) {
      const incomingItem = normalizeLocalCartItem(item);
      const cartItems = readLocalCartItems();
      const existingItem = cartItems.find((cartItem) => cartItem.key === incomingItem.key);
      if (existingItem) {
        existingItem.quantity += incomingItem.quantity;
      } else {
        cartItems.push(incomingItem);
      }
      updateLocalCartItems(cartItems);
    }

    const storedLocalCart = readLocalCartItems();
    updateLocalCartItems(storedLocalCart, { persist: false });

    localCartPage?.addEventListener("input", (event) => {
      const quantityInput = event.target.closest("[data-local-cart-page-line-quantity]");
      if (!quantityInput) return;
      const key = quantityInput.getAttribute("data-local-cart-key");
      const cartItems = readLocalCartItems();
      const item = cartItems.find((cartItem) => cartItem.key === key);
      if (!item) return;
      item.quantity = Math.max(1, Number(quantityInput.value || 1));
      updateLocalCartItems(cartItems);
    });

    document.addEventListener("click", (event) => {
      const quantityButton = event.target.closest("[data-local-cart-quantity-decrease], [data-local-cart-quantity-increase]");
      if (quantityButton) {
        event.preventDefault();
        const key = quantityButton.getAttribute("data-local-cart-key");
        const delta = quantityButton.hasAttribute("data-local-cart-quantity-increase") ? 1 : -1;
        const cartItems = readLocalCartItems();
        const item = cartItems.find((cartItem) => cartItem.key === key);
        if (!item) return;
        item.quantity = Math.max(1, item.quantity + delta);
        updateLocalCartItems(cartItems);
        return;
      }

      const removeButton = event.target.closest("[data-local-cart-remove]");
      if (!removeButton) return;
      event.preventDefault();
      const key = removeButton.getAttribute("data-local-cart-key");
      const cartItems = readLocalCartItems().filter((cartItem) => cartItem.key !== key);
      updateLocalCartItems(cartItems);
    });

    document.querySelectorAll("[data-local-add-to-bag]").forEach((button) => {
      button.addEventListener("click", () => {
        setAddButtonState(button, "loading");
        const quantityInput = button.closest("[data-product-page]")?.querySelector("[data-local-quantity]");
        const quantity = Math.max(1, Number(quantityInput?.value || 1));
        addLocalCartItem({
          title: button.getAttribute("data-product-title") || "BEAUPAN ritual",
          price: button.getAttribute("data-product-price") || "$68.00",
          image: button.getAttribute("data-product-image") || "",
          url: button.getAttribute("data-product-url") || window.location.pathname,
          quantity
        });
        openDrawerAfterInteraction("cart", document.querySelector('[data-drawer-open="cart"]'));
        setAddButtonState(button, "added");
        window.setTimeout(() => setAddButtonState(button, "idle"), 1400);
      });
    });

    document.querySelectorAll("[data-local-checkout]").forEach((button) => {
      button.addEventListener("click", () => {
        const status = button.closest(".cart-actions")?.querySelector("[data-local-checkout-status]");
        if (status) status.hidden = false;
      });
    });
  }

  document.querySelectorAll("[data-sort-option]").forEach((option) => {
    const grid = option.closest(".collection-page")?.querySelector(".product-grid");
    grid?.querySelectorAll("[data-product-card]").forEach((card, index) => {
      if (!card.hasAttribute("data-initial-index")) card.setAttribute("data-initial-index", String(index));
    });

    option.addEventListener("click", (event) => {
      event.preventDefault();
      const mode = option.getAttribute("data-sort-option");
      const section = option.closest(".collection-page");
      const grid = section?.querySelector(".product-grid");
      if (!grid) return;

      const cards = Array.from(grid.querySelectorAll("[data-product-card]"));
      const original = cards.map((card, index) => ({
        card,
        index: Number(card.getAttribute("data-initial-index") || index)
      }));
      const sorted = original.sort((a, b) => {
        if (mode === "price" || mode === "price-asc" || mode === "price-ascending") {
          return Number(a.card.getAttribute("data-product-price")) - Number(b.card.getAttribute("data-product-price"));
        }
        if (mode === "price-desc" || mode === "price-descending") {
          return Number(b.card.getAttribute("data-product-price")) - Number(a.card.getAttribute("data-product-price"));
        }
        if (mode === "popular") {
          return a.index - b.index;
        }
        if (mode === "title-asc" || mode === "title-ascending") {
          return (a.card.getAttribute("data-product-title") || "").localeCompare(b.card.getAttribute("data-product-title") || "");
        }
        if (mode === "title-desc" || mode === "title-descending") {
          return (b.card.getAttribute("data-product-title") || "").localeCompare(a.card.getAttribute("data-product-title") || "");
        }
        if (mode === "newest" || mode === "created-descending") {
          return Number(b.card.getAttribute("data-product-created") || 0) - Number(a.card.getAttribute("data-product-created") || 0) || a.index - b.index;
        }
        return a.index - b.index;
      });

      sorted.forEach(({ card }) => grid.appendChild(card));
      const label = option.textContent.trim();
      const toolbar = option.closest(".collection-toolbar");
      const sortLabel = toolbar?.querySelector("[data-sort-label]");
      const status = section.querySelector("[data-sort-status]");
      const statusTemplate = status?.getAttribute("data-sort-status-template") || "Sorted by {option}";
      option.closest(".filter-popover__panel")?.querySelectorAll("[data-sort-option]").forEach((item) => {
        if (item === option) {
          item.setAttribute("aria-current", "true");
        } else {
          item.removeAttribute("aria-current");
        }
      });
      if (sortLabel) sortLabel.textContent = label;
      if (status) {
        status.textContent = statusTemplate.replace("{option}", label);
        status.hidden = false;
      }
      option.closest("details")?.removeAttribute("open");
    });
  });

  document.querySelectorAll("[data-collection-search]").forEach((input) => {
    const section = input.closest(".collection-page");
    const grid = section?.querySelector(".product-grid");
    const empty = section?.querySelector("[data-collection-empty]");
    const count = section?.querySelector("[data-collection-count]");
    const countLabel = count?.querySelector("[data-collection-count-label]");
    const countTemplate = count?.getAttribute("data-count-template") || "{count} products";
    const countOne = count?.getAttribute("data-count-one") || "1 product";
    const promoCards = Array.from(grid?.querySelectorAll(".collection-promo-card") || []);
    if (!section || !grid) return;

    input.closest("form")?.addEventListener("submit", (event) => {
      event.preventDefault();
    });

    function updateCollectionSearch() {
      const query = input.value.trim().toLowerCase();
      let visibleCount = 0;
      grid.querySelectorAll("[data-product-card]").forEach((card) => {
        const keywords = card.getAttribute("data-product-keywords") || card.textContent.toLowerCase();
        const match = query.length === 0 || keywords.includes(query);
        card.hidden = !match;
        if (match) visibleCount += 1;
      });
      promoCards.forEach((card) => {
        card.hidden = query.length > 0;
      });
      if (empty) empty.hidden = visibleCount !== 0;
      if (countLabel) countLabel.textContent = visibleCount === 1 ? countOne : countTemplate.replace("{count}", String(visibleCount));
    }

    input.addEventListener("input", updateCollectionSearch);
    updateCollectionSearch();
  });

  document.querySelectorAll(".filter-popover").forEach((popover) => {
    popover.addEventListener("toggle", () => {
      if (!popover.open) {
        popover.classList.remove("is-drop-up");
        return;
      }
      document.querySelectorAll(".filter-popover[open]").forEach((openPopover) => {
        if (openPopover !== popover) openPopover.removeAttribute("open");
      });
      popover.classList.remove("is-drop-up");
      window.requestAnimationFrame(() => {
        const panel = popover.querySelector(".filter-popover__panel");
        if (!panel) return;
        const rect = panel.getBoundingClientRect();
        popover.classList.toggle("is-drop-up", rect.bottom > window.innerHeight - 16);
      });
    });
  });

  document.addEventListener("click", (event) => {
    const target = event.target;
    if (!(target instanceof Element) || target.closest(".filter-popover")) return;
    document.querySelectorAll(".filter-popover[open]").forEach((popover) => {
      popover.removeAttribute("open");
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    document.querySelectorAll(".filter-popover[open]").forEach((popover) => {
      popover.removeAttribute("open");
    });
  });

  document.querySelectorAll("[data-demo-form]").forEach((form) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      if (typeof form.checkValidity === "function" && !form.checkValidity()) {
        form.reportValidity?.();
        return;
      }
      const status = form.querySelector("[data-form-status]");
      form.classList.add("is-submitted");
      if (status) status.hidden = false;
    });
  });

  function setupAboutCarousels() {
    document.querySelectorAll("[data-about-carousel]").forEach((carousel) => {
      const slides = Array.from(carousel.querySelectorAll("[data-about-carousel-slide]"));
      if (slides.length < 2) return;

      const dotsContainer = carousel.querySelector("[data-about-carousel-dots]");
      const dots = dotsContainer
        ? slides.map((_, index) => {
          const dot = document.createElement("span");
          dot.className = `about-beaupan__carousel-dot${index === 0 ? " is-active" : ""}`;
          dotsContainer.appendChild(dot);
          return dot;
        })
        : [];
      let activeIndex = Math.max(slides.findIndex((slide) => slide.classList.contains("is-active")), 0);
      let timer = null;
      const shouldAutoplay = !(prefersReducedMotion?.matches && !body.hasAttribute("data-local-motion-preview"));
      const interval = Number(carousel.dataset.carouselInterval || 3000);

      function showSlide(nextIndex) {
        const normalizedIndex = (nextIndex + slides.length) % slides.length;
        slides[activeIndex].classList.remove("is-active");
        dots[activeIndex]?.classList.remove("is-active");
        activeIndex = normalizedIndex;
        slides[activeIndex].classList.add("is-active");
        dots[activeIndex]?.classList.add("is-active");
      }

      function stopAutoplay() {
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
      }

      function startAutoplay() {
        if (!shouldAutoplay || timer) return;
        timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
      }

      carousel.querySelector("[data-about-carousel-prev]")?.addEventListener("click", () => {
        stopAutoplay();
        showSlide(activeIndex - 1);
        startAutoplay();
      });

      carousel.querySelector("[data-about-carousel-next]")?.addEventListener("click", () => {
        stopAutoplay();
        showSlide(activeIndex + 1);
        startAutoplay();
      });

      carousel.addEventListener("mouseenter", stopAutoplay);
      carousel.addEventListener("mouseleave", startAutoplay);
      carousel.addEventListener("focusin", stopAutoplay);
      carousel.addEventListener("focusout", startAutoplay);
      startAutoplay();
    });
  }

  setupAboutCarousels();

  function setupLuxuryMotion() {
    const compactMotionQuery = window.matchMedia?.("(max-width: 640px)");
    const isCompactMotion = compactMotionQuery?.matches;
    const parallaxTargets = Array.from(document.querySelectorAll(".hero__image, .collection-hero__media img, .brand-hero__media img, .image-story__media img, .dual-feature__media img, .about-beaupan__lead-media img, .about-beaupan__story-media img"));
    if (parallaxTargets.length === 0) return;
    if (prefersReducedMotion?.matches) {
      parallaxTargets.forEach((target) => {
        target.classList.remove("motion-parallax");
        target.style.removeProperty("--motion-y");
        target.style.removeProperty("transform");
      });
      return;
    }
    parallaxTargets.forEach((target) => target.classList.add("motion-parallax"));
    let ticking = false;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function updateParallax() {
      ticking = false;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      parallaxTargets.forEach((target) => {
        const rect = target.getBoundingClientRect();
        if (rect.bottom < -120 || rect.top > viewportHeight + 120) return;
        const center = rect.top + rect.height / 2;
        const progress = (center - viewportHeight / 2) / viewportHeight;
        const range = target.classList.contains("hero__image")
          ? (isCompactMotion ? 8 : 18)
          : (isCompactMotion ? 5 : 10);
        target.style.setProperty("--motion-y", `${clamp(progress * -range, -range, range).toFixed(2)}px`);
      });
    }

    function requestParallaxUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    }

    window.addEventListener("scroll", requestParallaxUpdate, { passive: true });
    window.addEventListener("resize", requestParallaxUpdate);
    requestParallaxUpdate();
  }

  setupLuxuryMotion();

  const revealTargets = document.querySelectorAll(".section-heading, .product-card, .image-story, .dual-feature__card, .brand-values article, .brand-strip, .newsletter, .collection-hero__copy, .collection-hero__media, .brand-hero__media, .brand-hero__content, .about-beaupan__lead-media, .about-beaupan__lead-copy, .about-beaupan__story, .contact-page__intro, .contact-form, .product-gallery, .product-page__info, .search-page, .site-footer__meta");
  if (prefersReducedMotion?.matches) {
    revealTargets.forEach((target) => {
      target.classList.add("reveal-ready", "is-visible");
      target.style.setProperty("--reveal-delay", "0ms");
    });
  } else if ("IntersectionObserver" in window) {
    const compactRevealQuery = window.matchMedia?.("(max-width: 640px)");
    const isCompactMotion = compactRevealQuery?.matches;
    const revealStep = isCompactMotion ? 24 : 55;
    const maxRevealDelay = isCompactMotion ? 96 : 275;
    const initialTargets = [];
    revealTargets.forEach((target, index) => {
      const rect = target.getBoundingClientRect();
      const isInitialViewport = rect.bottom > 0 && rect.top < window.innerHeight;
      target.classList.add("reveal-ready");
      target.style.setProperty("--reveal-delay", isInitialViewport ? "0ms" : `${Math.min((index % 6) * revealStep, maxRevealDelay)}ms`);
      if (isInitialViewport) initialTargets.push(target);
    });
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        initialTargets.forEach((target) => target.classList.add("is-visible"));
      });
    });
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: "0px",
        threshold: 0
      }
    );
    revealTargets.forEach((target) => {
      if (!target.classList.contains("is-visible")) observer.observe(target);
    });
  } else {
    revealTargets.forEach((target) => target.classList.add("is-visible"));
  }

  document.querySelectorAll("[data-scroll-target]").forEach((link) => {
    link.addEventListener("click", (event) => {
      const target = document.querySelector(link.getAttribute("href"));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: prefersReducedMotion?.matches ? "auto" : "smooth", block: "start" });
    });
  });

  window.addEventListener("scroll", setHeaderState, { passive: true });
  setHeaderState();
  markActiveNavigation();
})();
